import { Stack, Heading, Box, Grid, GridItem } from '../../components';
import { PermissionGuard } from '../../context';

function StatCard({
  title,
  value,
  description,
}: {
  title: string;
  value: string;
  description: string;
}) {
  return (
    <Box padding="lg" className="stat-card">
      <Stack spacing="xs">
        <span style={{ fontSize: '0.875rem', color: '#666' }}>{title}</span>
        <span style={{ fontSize: '2rem', fontWeight: 700, color: '#333' }}>{value}</span>
        <span style={{ fontSize: '0.875rem', color: '#888' }}>{description}</span>
      </Stack>
    </Box>
  );
}

export function StaffDashboard() {
  return (
    <Box padding="lg">
      <Stack spacing="xl">
        <Stack spacing="sm">
          <Heading level="h1" size="2xl">
            Staff Dashboard
          </Heading>
          <p>Manage courses, students, and enrollment data.</p>
        </Stack>

        {/* Stats Overview */}
        <section>
          <Stack spacing="md">
            <Heading level="h2" size="lg">
              Overview
            </Heading>
            <Grid columns={4} gap="lg">
              <GridItem>
                <StatCard title="Total Courses" value="156" description="Active this semester" />
              </GridItem>
              <GridItem>
                <StatCard
                  title="Enrolled Students"
                  value="2,847"
                  description="+12% from last semester"
                />
              </GridItem>
              <GridItem>
                <StatCard title="Sections" value="423" description="Across all departments" />
              </GridItem>
              <GridItem>
                <StatCard title="Pending Requests" value="34" description="Awaiting approval" />
              </GridItem>
            </Grid>
          </Stack>
        </section>

        {/* Admin Section - Permission Protected */}
        <PermissionGuard permission="admin:access">
          <section>
            <Stack spacing="md">
              <Heading level="h2" size="lg">
                Administration
              </Heading>
              <p>Admin-only section visible to users with admin:access permission.</p>
            </Stack>
          </section>
        </PermissionGuard>
      </Stack>
    </Box>
  );
}
